import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import { useDispatch, useSelector } from 'react-redux';
import { receiveNotification } from '../redux/slices/notificationsSlice';

// Same-origin by default: in production the nginx proxy serves /ws/socket.io/
// (and the CRA dev server proxies it in local dev), so connect through the
// page's own origin instead of a hardcoded backend address.
const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;

const useSocketConnect = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const socketRef = useRef(null);

  useEffect(() => {
    if (!user?.id) {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
      return;
    }

    if (!socketRef.current) {
      socketRef.current = io(SOCKET_URL, {
        // Backend requires a valid JWT on socket connect (room join is
        // restricted to the token user's own notification room).
        auth: { token: localStorage.getItem("token") || undefined },
        transports: ['websocket'],
        path: "/ws/socket.io",
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        randomizationFactor: 0.5,
        autoConnect: true,
      });

      socketRef.current.on('connect', () => {
        socketRef.current.emit('join', `user_${user.id}`);
      });

      socketRef.current.on(`user_${user.id}`, (notification) => {
        dispatch(receiveNotification(notification));
      });

      socketRef.current.on('disconnect', (_reason) => {
      });

      socketRef.current.on('connect_error', (_error) => {
      });

    } else {
      socketRef.current.emit('join', `user_${user.id}`);
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.off(`user_${user.id}`);
      }
    };
  }, [user, dispatch]);

  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  return socketRef.current;
};

export default useSocketConnect;
